import clsx from "clsx";

export const buttonWrapper = clsx("z-60 absolute right-0 mt-[30px]")
export const buttonContainer = clsx(
    "absolute flex items-center justify-center rounded-md",
);
export const bottomLine = clsx("h-[2px] w-[40px] bg-black rounded-xl");
export const line = clsx(bottomLine + " mb-2");